import React from "react";
import Img from "../Img";
import Odd from "../Odd";
import Link from "../../router/Link";
import { getEventUrl } from "../../prematch/Prematch";
import { useLiveData } from "../../live/LiveDataProvider";
import Badge from "../Badge";
import { getLabel } from "../../InitData";
import BettingClosedMessageInline from "../BettingClosedMessageInline";

export default function TopLive() {
    const liveData = useLiveData();

    
    if (liveData == null || liveData.matches.length === 0) {
        return null;
    }

    const events = liveData.matches.slice(0, 10);

    return (
        <div className="c_9">
            <div className="c_9_1">
                <Img className="c_9_1_1" src="top_choice.svg" height="16px" width="16px" />
                <span className="c_9_1_2">{getLabel('general.top_live_matches')}</span>
            </div>
            <div className="c_9_2">
                {events.map(e => {
                    const bet = e.bets?.[0] ?? null;
                    const bettingClosed = e.giocabilita === false || bet == null;

                    return (
                        <Link href={getEventUrl(e)} key={e.uniqueId} className="c_10">
                            <div className="c_10_1">
                                <div className="c_10_1_1">
                                    <Badge desc={getLabel('general.live')} noMargin={true} />
                                </div>
                                <div className="c_10_1_1">{e.sportDesc} - {e.categoryDesc} - {e.sportDesc}</div>
                            </div>
                            <div className="c_10_2">{e.team1} - {e.team2}</div>
                            {bettingClosed ?
                                <div className="c_10_4">
                                    <BettingClosedMessageInline />
                                </div>
                                :
                                <div className="c_10_3">
                                    <div className="c_10_3_1">
                                        <div className="c_10_3_1_1">{bet.desc}</div>
                                    </div>
                                    <div className="c_10_3_2">
                                        {bet.odds.map(o =>
                                            <Odd key={o.uniqueId} data={o} showDesc={true} />
                                        )}
                                    </div>
                                </div>
                            }
                        </Link>
                    );
                })}
            </div>
        </div>
    );
}
